module.exports = __webpack_public_path__ + "img/pba2.b292ee76.jpg";